import { createStore, applyMiddleware, compose } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import thunkMiddleware from 'redux-thunk';

import { isProd } from '../api/utils';
import { routerEnhancer, routerMiddleware } from '../routes';
import { reducers } from './reducers';

const composeEnhancers = (!isProd() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(
  enableBatching(reducers),
  {},
  composeEnhancers(
    routerEnhancer,
    applyMiddleware(thunkMiddleware, routerMiddleware),
  ),
);




// WEBPACK FOOTER //
// ./src/redux/store.js